var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-post-list"},_vm._l((_vm.posts),function(post,index){return (!_vm.filter || _vm.filter(post))?_c('router-link',{key:post.id,staticClass:"view-post-list-row",attrs:{"to":{
			name: 'post',
			params: {
				id: post.id
			}
		}}},[_c('post-list-item',{attrs:{"post":post}})],1):_vm._e()}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f010f01","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/models/PostList.vue
// module id = 329
// module chunks = 0